import styled from 'styled-components';
import DeleteIcon from '@material-ui/icons/Delete';

export const Container = styled.div`
  margin: 15px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 2px solid black;
  color: black;
  align-items: center;

  h1 {
    margin: 0;
    font-size: 22px;
  }

  button {
    height: 40px;
    background-color: black;
    color: white;
    :hover,
    :focus,
    :active {
      background-color: black;
      color: white;
    }
  }
`;

export const Body = styled.div``;

export const Pagination = styled.div`
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  button {
    background-color: transparent;
    box-shadow: none;
    padding: 0;
    min-width: fit-content;
    :hover,
    :active,
    :focus,
    :disabled {
      background-color: transparent;
      box-shadow: none;
    }
  }
`;

export const Arts = styled.div`
  gap: 30px;
`;

export const Art = styled.div`
  display: flex;
  height: 50px;
  align-items: center;
  gap: 40px;
  margin: 0 20px;
  justify-content: space-between;

  div {
    width: 50px;
    height: 50px;
    padding: 0 !important;
  }
  img {
    max-width: 50px;
    max-height: 50px;
  }
`;

export const StyledDeleteIcon = styled(DeleteIcon)`
  position: absolute;
  top: 0;
  right: 0;
  color: red;
  cursor: pointer;
`;

export const NoDataFound = styled.h2`
  color: red;
  font-weight: bold;
  text-align: center;
`;

export const StyledTabs = styled.div`
  background-color: white;
  .MuiAppBar-colorPrimary {
    background-color: black;
  }
  .MuiTabs-indicator {
    background-color: white;
  }
`;

export const FileName = styled.h3`
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FileFormat = styled.h4`
  margin: 5px 0 0;
  text-align: center;
  text-transform: uppercase;
`;

export const DrawerWrapper = styled.div`
  width: 50vw;
  margin: 10px;
`;

export const SearchBar = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 20px;
  border-bottom: 1px solid #a1a1a1;
  padding-bottom: 20px;
  margin-bottom: 20px;
`;

export const SearchTextbox = styled.div`
  .MuiFormControl-root {
    width: 100%;
  }
`;

export const SearchBarButtons = styled.div`
  display: flex;
  gap: 10px;
  button:disabled {
    opacity: 0.5;
  }
  button:nth-child(1) {
    background-color: black;
    color: white;
    :hover,
    :focus,
    :active {
      background-color: black;
      color: white;
    }
  }
  button:nth-child(2) {
    background-color: red;
    color: white;
    :hover,
    :focus,
    :active {
      background-color: red;
      color: white;
    }
  }
`;
export const ArtFile = styled.div`
  .src {
    background-image: url(https://developer.android.com/reference/android/images/graphics/composite_CLEAR.png?hl=vi);
    display: flex;
    background-size: 50%;
  }

  img {
    width: 150px;
  }
`;
